var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1980_6511",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1980_6511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 15.9987C14.534 15.9987 13.2784 15.4765 12.234 14.432C11.1895 13.3876 10.6673 12.132 10.6673 10.6654C10.6673 9.1987 11.1895 7.94314 12.234 6.8987C13.2784 5.85425 14.534 5.33203 16.0007 5.33203C17.4673 5.33203 18.7229 5.85425 19.7673 6.8987C20.8118 7.94314 21.334 9.1987 21.334 10.6654C21.334 12.132 20.8118 13.3876 19.7673 14.432C18.7229 15.4765 17.4673 15.9987 16.0007 15.9987ZM5.33398 26.6654V22.932C5.33398 22.1765 5.52843 21.482 5.91732 20.8487C6.30621 20.2154 6.82287 19.732 7.46732 19.3987C8.8451 18.7098 10.2451 18.1931 11.6673 17.8487C13.0895 17.5043 14.534 17.332 16.0007 17.332C17.4673 17.332 18.9118 17.5043 20.334 17.8487C21.7562 18.1931 23.1562 18.7098 24.534 19.3987C25.1784 19.732 25.6951 20.2154 26.084 20.8487C26.4729 21.482 26.6673 22.1765 26.6673 22.932V26.6654H5.33398Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d4d38c990e9e042a4841ab21d6b67d0d.svg";
export { ForwardRef as ReactComponent };